import React from 'react';

export const DISCLAIMER_TEXT =
  'Estimates only — not an appraisal, guarantee, or legal advice.';

export default function Disclaimer() {
  return (
    <p style={style} data-testid="disclaimer">
      {DISCLAIMER_TEXT}
    </p>
  );
}

const style = {
  fontSize: '12px',
  color: '#64748b',
  fontStyle: 'italic',
  margin: '16px 0 0',
  lineHeight: 1.5,
};
